<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <footer>
        <div class="holder">
            <div class="contacts_block">
                <strong>{{ content[lang]['CONTACT_INFORMATION'] }}</strong>

                <p>{{ content[lang]['ADDRESS_1'] }}</p>

                <p>{{ content[lang]['ADDRESS_2'] }}</p>

                <p><a href="tel:+78435280548">+7 (843) 528-05-48</a></p>

                <p class="email"><a href="mailto:office@gracelogic.com">office@gracelogic.com</a></p>
            </div>
            <div class="menu">
                <div class="menu_block">
                    <div class="title">{{ content[lang]['SOLUTIONS'] }}</div>
                    <ul>
                        <li><a v-bind:href="'/' + lang + '/solutions/platform'">GL Enterprise Platform</a></li>
                        <li><a v-bind:href="'/' + lang + '/solutions/cloud-credit'">Cloud Credit</a></li>
                        <li><a v-bind:href="'/' + lang + '/solutions/bid-pro'">Bid PRO</a></li>
                        <li><a v-bind:href="'/' + lang + '/solutions/loyalty'">Loyalty</a></li>
                        <li><a v-bind:href="'/' + lang + '/solutions/global-centre'">Global Centre</a></li>
                        <li><a v-bind:href="'/' + lang + '/solutions/resource-management'">Resource Management</a></li>
                        <li><a v-bind:href="'/' + lang + '/solutions/aspa'">ASPA</a></li>
                    </ul>
                </div>
                <div class="menu_block">
                    <div class="title">{{ content[lang]['SERVICES'] }}</div>
                    <ul>
                        <li><a v-bind:href="'/' + lang + '/services/engineering'">{{ content[lang]['DESIGN'] }}</a></li>
                        <li><a v-bind:href="'/' + lang + '/services/development'">{{ content[lang]['DEVELOPMENT'] }}</a></li>
                        <li><a v-bind:href="'/' + lang + '/services/consulting'">{{ content[lang]['CONSULTING'] }}</a></li>
                    </ul>
                </div>
                <div class="menu_block">
                    <div class="title"><a v-bind:href="'/' + lang + '/news'">{{ content[lang]['PRESS_CENTER'] }}</a></div>
                    <div class="title"><a v-bind:href="'/' + lang + '/company/about'">{{ content[lang]['COMPANY'] }}</a></div>
                </div>
            </div>
            <div class="copyright">&copy; 2014-{{ getCurrentYear() }}, {{ content[lang]['OOO_GRACE_LOGIC'] }}</div>
        </div>
    </footer>
</template>

<script>
    export default {
        data: function () {
            return {
                content: {
                    ru: {
                        CONTACT_INFO: "Контактная информация",
                        ADDRESS_1: "Российская Федерация, г. Казань",
                        ADDRESS_2: "ул. Гарифьянова, д. 28а",
                        SOLUTIONS: "Решения",
                        SERVICES: "Услуги",
                        DESIGN: "Проектирование",
                        DEVELOPMENT: "Разработка",
                        CONSULTING: "Консалтинг",
                        PRESS_CENTER: "Пресс-центр",
                        COMPANY: "Компания",
                        OOO_GRACE_LOGIC: "ООО \"Грейс Лоджик\""
                    },
                    en: {
                        CONTACT_INFO: "Contact information",
                        ADDRESS_1: "Russia, Kazan,",
                        ADDRESS_2: "Garifyanov str., 28a",
                        SOLUTIONS: "Solutions",
                        SERVICES: "Services",
                        DESIGN: "Design",
                        DEVELOPMENT: "Software development",
                        CONSULTING: "Consulting",
                        PRESS_CENTER: "Press center",
                        COMPANY: "Company",
                        OOO_GRACE_LOGIC: "Grace Logic LLC"
                    },
                    zh: {
                        CONTACT_INFO: "联系方式",
                        ADDRESS_1: "俄罗斯联邦，喀山市，",
                        ADDRESS_2: "Garifyanova路，28  a 号",
                        SOLUTIONS: "解决方案",
                        SERVICES: "服务",
                        DESIGN: "设计",
                        DEVELOPMENT: "软件的开发",
                        CONSULTING: "咨询",
                        PRESS_CENTER: "新闻处",
                        COMPANY: "公司",
                        OOO_GRACE_LOGIC: "有限公司 \"Grace Logic\""
                    },
                    hi: {
                        CONTACT_INFO: "संपर्क जानकारी",
                        ADDRESS_1: "रूसी संघ, कज़ान शहर",
                        ADDRESS_2: "Garif'yanov सड़क, 28А घर।",
                        SOLUTIONS: "समाधान",
                        SERVICES: "सेवाएं",
                        DESIGN: "डिजाइनिंग",
                        DEVELOPMENT: "सॉफ्टवेयरकाविकास",
                        CONSULTING: "परामर्श",
                        PRESS_CENTER: "प्रेस सेंटर",
                        COMPANY: "कंपनी",
                        OOO_GRACE_LOGIC: "Grace Logic LLC"
                    }
                }
            }
        },
        computed: {
            lang: function () {
                return this.$route.params.lang != null ? this.$route.params.lang : Application.props.defaultLang;
            }
        },
        methods: {
            getCurrentYear: function() {
                let now = new Date();
                return now.getFullYear();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// VFooter.vue?de77b2c8